import { toast } from '@zerodevx/svelte-toast';
import type { SvelteToastOptions } from '@zerodevx/svelte-toast/stores';

export const toastErrorTheme: SvelteToastOptions = {
    theme: {
        // '--toastBackground': '#F56565F0',
        '--toastBackground': '#fcd6d6',
        '--toastBarBackground': '#fdaeae',
        '--toastColor': 'black'
    },
    pausable: true,
    duration: 10000
};

export const toastWarningTheme: SvelteToastOptions = {
    theme: {
        '--toastBackground': '#e5d811cf',
        '--toastBarBackground': '#e5ba11e8',
        '--toastColor': 'black'
    },
    pausable: true
};

export const toastSuccessTheme: SvelteToastOptions = {
    theme: {
        //	'--toastBackground': '#369DF4F0',
        '--toastBackground': '#fcf3d6',
        // '--toastBarBackground': '#2864ccF0'
        '--toastBarBackground': '#ffda63',
        '--toastColor': 'black'
    },
    pausable: true
};

export const failure = (msg: string, extraOptions?: SvelteToastOptions) => {
    toast.push(msg, extraOptions ? { ...toastErrorTheme, ...extraOptions } : toastErrorTheme);
};

export const warning = (msg: string, extraOptions?: SvelteToastOptions) => {
    toast.push(msg, extraOptions ? { ...toastWarningTheme, ...extraOptions } : toastWarningTheme);
};

export const success = (msg: string, extraOptions?: SvelteToastOptions) => {
    toast.push(msg, extraOptions ? { ...toastSuccessTheme, ...extraOptions } : toastSuccessTheme);
};